import Model from '@/model/endpointHttp'
import JSEncrypt from 'jsencrypt'
class Login extends Model {
  constructor() {
    super()
    this.baseURL = process.env.VUE_APP_CS_API + '/v1'
  }
  getMarketList(options = {}) {
    options.url = '/common/market_list'
    return this.get(options)
  }

  async getToken(options = {}) {
    options.baseURL = process.env.VUE_APP_APISERVER
    options.url = '/login/web/auth/password'
    // 使用rsa加密 密码后调用登录接口
    const encryptor = new JSEncrypt()
    // 获取公钥
    const data = await this.get({
      baseURL: process.env.VUE_APP_APISERVER,
      url: '/login/web/auth/publicKey'
    })
    encryptor.setPublicKey(data.key)
    options.rawStatusCode = true
    options.data.password = encryptor.encrypt(options.data.password)
    return this.post(options)
  }

  // 校验token
  checkToken(params) {
    return this.get({
      baseURL: process.env.VUE_APP_APISERVER,
      url: '/login/web/auth/check_token',
      params
    })
  }

  loginIM(options = {}) {
    options.url = 'im/genSig'
    return this.get(options)
  }

  autoReplay(options = {}) {
    options.baseURL = process.env.VUE_APP_API + '/v1'
    options.url = '/member/im/auto_reply'
    return this.post(options)
  }

  login(options = {}) {
    options.url = 'auth/web/login'
    return this.post(options)
  }

  loginCs(options = {}) {
    options.baseURL = this.baseURL
    options.url = 'common/tx/im/session'
    return this.post(options)
  }

  onlyId(options = {}) {
    options.baseURL = process.env.VUE_APP_CS_API
    options.url = '/v1/common/tx/im/uniqueSign'
    return this.post(options)
  }

  onlineState(options = {}) {
    options.baseURL = this.baseURL
    options.url = '/common/tx/im/onlineState'
    return this.get(options)
  }

  // 注册 发送短信验证码
  sendRegisterCode(options = {}) {
    options.url = 'auth/register/code'
    return this.post(options)
  }
  // 注册接口（注册加入固定参数：来源）
  register(options = {}) {
    options.baseURL = process.env.VUE_APP_APISERVER
    options.url = '/ums/register/v1/register'
    options.data.source = 'china'
    options.rawStatusCode = true
    return this.post(options)
  }
  // 短信登入 发送验证码
  sendSms(options = {}) {
    options.url = 'auth/send/sms'
    return this.get(options)
  }

  // 短信登录获取验证码新
  sendSmsNew(options = {}) {
    options.url = 'auth/send/code'
    return this.get(options)
  }

  // 短信登录获取验证码新
  sendSmsInLoginRegister(options = {}) {
    options.url = 'auth/register_login/code'
    return this.post(options)
  }

  // 验证码登录新
  smsLoginRegister(options = {}) {
    options.baseURL = process.env.VUE_APP_APISERVER
    options.url = '/login/web/auth/sms'
    options.rawStatusCode = true
    return this.post(options)
  }
  logout(options = {}) {
    options.url = 'auth/web/logOut'
    return this.post(options)
  }

  /**
   * 进货单商品列表（购物车）
   * @param {*} options
   * @returns
   */
  getCartDetail(options = {}) {
    options.baseURL = `${process.env.VUE_APP_APISERVER}/oms/v2`
    options.url = '/buyer/cart/index'
    options.withCredentials = false
    options.is_valid = true
    return this.post(options)
  }

  // 购物车新增
  addToCart(options = {}) {
    options.baseURL = process.env.VUE_APP_OMS_PRODUCTQUERY
    options.url = '/buyer/cart/add'
    return this.post(options)
  }

  // 更新购物车
  updateCart(options = {}) {
    options.baseURL = process.env.VUE_APP_OMS_PRODUCTQUERY
    options.url = '/buyer/cart/update'
    return this.put(options)
  }

  // 购物车删除
  deleteFromCart(options = {}) {
    options.baseURL = process.env.VUE_APP_OMS_PRODUCTQUERY
    options.url = '/buyer/cart/destroy'
    options.normalizeMethod = 'DELETE'
    return this.delete(options)
  }

  // 清空购物车
  clearCart(options = {}) {
    options.baseURL = process.env.VUE_APP_OMS_PRODUCTQUERY
    options.url = '/buyer/cart/destroy/all'
    return this.delete(options)
  }

  // 选中商品金额计算
  countSelected(options = {}) {
    options.baseURL = `${process.env.VUE_APP_APISERVER}/oms/v2`
    options.url = `/buyer/cart/index`
    return this.post(options)
  }

  /**
   * 消息通知接口
   */

  // 消息通知列表
  getList(options = {}) {
    options.url = `member/notify?page=${options.data.page}&page_size=${options.data.page_size}`
    return this.get(options)
  }

  // 消息通知删除
  deleteNotice(options = {}) {
    options.url = `member/notify/${options.id}`
    return this.delete(options)
  }

  // 获取个人中心头部消息通知数量
  notifyNum(options = {}) {
    options.url = 'member/notify/unread_summary'
    return this.get(options)
  }

  notifyRead(options = {}) {
    options.url = 'member/notify/read'
    return this.post(options)
  }
  getAreaCode(options = {}) {
    options.url = 'common/area_code'
    return this.get(options)
  }

  loginCookie(data) {
    return this.post({
      url: 'auth/login/cookie',
      data
    })
  }

  singleExit(options = {}) {
    options.url = 'auth/logout'
    return this.post(options)
  }

  getHomeActiveInfo(options = {}) {
    options.baseURL = process.env.VUE_APP_LICENSE_URL
    options.url = '/common/getcurrenttime'
    options.withCredentials = false
    return this.get(options)
  }

  getHomeImgConfig(options = {}) {
    options.baseURL = process.env.VUE_APP_LICENSE_URL
    options.url = '/ambient/zhstation'
    options.withCredentials = false
    return this.get(options)
  }

  userInfo(params) {
    return this.get({
      baseURL: process.env.VUE_APP_APISERVER,
      url: '/ums/userinfo/index/user/info',
      params
    })
  }
}

export default new Login()
